import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue"
import i18n from '@/lang/i18n';
import ConfirmationModal from "@/components/Common/ConfirmationModalBase.vue";

type Props = {
  modalState: boolean,
  loading?: boolean,
  title: string,
  note: string,
  rightBtnName: string
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    modalState: { type: Boolean, default: false },
    loading: { type: Boolean },
    title: {},
    note: {},
    rightBtnName: {}
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit

function confirm() {
  emits("confirm");
}

function cancel() {
  emits("cancel");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConfirmationModal, {
    title: props.title,
    note: props.note,
    modalState: props.modalState,
    rightBtnName: props.rightBtnName,
    rightBtnClass: "bg-warning",
    onRightBtnAction: confirm,
    leftBtnName: _unref(i18n).global.t('common.cancelBtn'),
    leftBtnClass: "reset-btn",
    onLeftBtnAction: cancel,
    modalMaxWidth: "40%",
    rightLoading: props.loading
  }, null, 8, ["title", "note", "modalState", "rightBtnName", "leftBtnName", "rightLoading"]))
}
}

})